// Jours fériés français (métropole)
// Algorithme de Pâques : méthode "Anonymous Gregorian" (Meeus/Jones/Butcher)

function easterDate(year) {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(year, month - 1, day);
}

function addDays(d, n) {
  const x = new Date(d); x.setDate(x.getDate() + n); return x;
}

function toIso(d) {
  const y = d.getFullYear(), m = String(d.getMonth() + 1).padStart(2, '0'), dd = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${dd}`;
}

// Retourne une map { 'YYYY-MM-DD': 'nom du jour férié' }
export function joursFeriesFR(year) {
  const easter = easterDate(year);
  const days = [
    { date: new Date(year, 0, 1), name: "Jour de l'An" },
    { date: addDays(easter, 1), name: 'Lundi de Pâques' },
    { date: new Date(year, 4, 1), name: 'Fête du Travail' },
    { date: new Date(year, 4, 8), name: 'Victoire 1945' },
    { date: addDays(easter, 39), name: 'Ascension' },
    { date: addDays(easter, 50), name: 'Lundi de Pentecôte' },
    { date: new Date(year, 6, 14), name: 'Fête nationale' },
    { date: new Date(year, 7, 15), name: 'Assomption' },
    { date: new Date(year, 10, 1), name: 'Toussaint' },
    { date: new Date(year, 10, 11), name: 'Armistice 1918' },
    { date: new Date(year, 11, 25), name: 'Noël' },
  ];
  const map = {};
  for (const d of days) map[toIso(d.date)] = d.name;
  return map;
}

// Version multi-années (cache par année)
const _cache = {};
export function isJourFerieFR(dateIso) {
  const y = parseInt(dateIso.slice(0, 4), 10);
  if (!_cache[y]) _cache[y] = joursFeriesFR(y);
  return _cache[y][dateIso] || null;
}
